module.exports = __webpack_public_path__ + "static/media/Knights-bridge-Gate-MasterDeed.99e1069e.pdf";